import actions from "./actions";

const initState = {
    coupon: null,
    readState: null,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.COUPON_READ_REQUEST:
            return {
                ...state,
                readState: 'request',
            };
        case actions.COUPON_READ_SUCCESS:
            return {
                ...state,
                readState: 'success',
                coupon: action.coupon,
            };
        case actions.COUPON_READ_ERROR:
            return {
                ...state,
                readState: 'error',
                coupon: null,
            };
        case actions.COUPON_SET:
            return {
                ...state,
                coupon: action.coupon,
            };
        case actions.COUPON_RESET:
            return {
                ...initState,
            };
        default:
            return state;
    }
}
